'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPubnubMessageRecord = undefined;

var _PubNubMessageRecord = require('../records/PubNubMessageRecord');

var _PubNubMessageRecord2 = _interopRequireDefault(_PubNubMessageRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isPubnubMessageRecord = exports.isPubnubMessageRecord = function isPubnubMessageRecord(message) {
  return message instanceof _PubNubMessageRecord2.default;
};